var SystemSlider = {};
var supportsOrientationChange = ('onorientationchange' in window),
  orientationEvent = supportsOrientationChange ? 'orientationchange' : 'resize';
SystemSlider.slider = function () {
  var $systemSlider = $('.js-system-slider');
  if ($systemSlider.length === 0) {
    return;
  }

  // let isStatus = ($systemSlider.children().length > 1 ? true : false);
  var systemSliderCount = $('.systems:not(.systems-part) .system-item').length;

  // Flickity Options
  var options = {
    cellAlign: 'center',
    wrapAround: true,
    prevNextButtons: true,
    pageDots: true,
    dragThreshold: 3,
    draggable: true,
    selectedAttraction: 0.01,
    friction: 0.15
  };
  if (matchMedia('screen and (min-width: 576px)').matches) {
    if (systemSliderCount >= 3) {
      options = {
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        pageDots: true,
        dragThreshold: 3,
        draggable: false,
        adaptiveHeight: true,
        selectedAttraction: 0.01,
        friction: 0.15
      };
    } else {
      options = {
        cellAlign: 'center',
        wrapAround: false,
        prevNextButtons: true,
        pageDots: true,
        dragThreshold: 3,
        draggable: false,
        adaptiveHeight: true,
        selectedAttraction: 0.01,
        friction: 0.15
      };
    }
  }
  $systemSlider.on('ready.flickity', function () {
    var selectedItem = document.querySelector('.systems:not(.systems-part) .system-item.is-selected');
    if (!selectedItem) return;
    var scaledImage = selectedItem.getBoundingClientRect().height;
    setTimeout(function () {
      $systemSlider.css('visibility', 'visible');
      $systemSlider.find('.flickity-viewport').css('min-height', scaledImage + 'px');
    }, 1000);
  });

  // Check if has prev / next btn
  if ($systemSlider.data('has-btn') === false) {
    options.prevNextButtons = false;
    options.pageDots = false;
  }

  // var $slider = $systemSlider.flickity('destroy');
  var $slider = $systemSlider.flickity(options);
  var flktySystem = $slider.data('flickity');
  var count = flktySystem.cells !== null || typeof flktySystem.cells !== 'undefined' ? flktySystem.cells.length : 0;
  if (count == 3 || count == 2) {
    if (matchMedia('screen and (min-width: 576px)').matches) {
      options.wrapAround = false, $systemSlider.flickity(options);
      $slider.flickity('select', 1);
    }
  }
  if (matchMedia('screen and (min-width: 576px)').matches) {
    $slider.on('dragMove.flickity dragEnd.flickity change.flickity', function () {
      // $systemSlider.flickity('resize');
      $systemSlider.flickity('reposition');
      if (flktySystem.cells && flktySystem.selectedIndex == flktySystem.cells.length - 1) {
        $systemSlider.addClass('last-cell-selected');
      } else {
        $systemSlider.removeClass('last-cell-selected');
      }
    });
    $slider.on('settle.flickity', function () {
      $systemSlider.flickity('reposition');
    });
  }
  if ($systemSlider.length > 0) {
    window.addEventListener(orientationEvent, function () {
      $systemSlider.on('select.flickity', function () {
        var selectedItem = document.querySelector('.systems:not(.systems-part) .system-item.is-selected');
        if (selectedItem) {
          var scaledImage = selectedItem.getBoundingClientRect().height;
        }
        setTimeout(function () {
          $systemSlider.css('visibility', 'visible');
          $systemSlider.find('.flickity-viewport').css('min-height', scaledImage + 'px');
        }, 1000);
      });
    }, false);
  }
  $(window).on('load', function () {
    $systemSlider.flickity('resize');
  });
};
SystemSlider.slider();
window.SystemSlider = SystemSlider;


// WEBPACK FOOTER //
// ./scripts/components/sliders/system-slider.js